import { render } from "./VideoBackground.vue?vue&type=template&id=9eed53e0"
const script = {}

import "./VideoBackground.vue?vue&type=style&index=0&id=9eed53e0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__